import React from 'react';
import { metrics } from '../../data/site';
export function MomentumStrip() {
  return <section aria-label="Campaign momentum" className="border-b border-sand-200 bg-sand-100" data-id="element-265" data-mp="c6jqryahsv9v">
      <div className="mx-auto max-w-content px-4 py-10 pt-12 sm:px-6 lg:px-10 lg:py-12" data-id="element-266" data-mp="7fblneg73w2i">
        <dl className="grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-4" data-id="element-267" data-mp="3dybwt9zf8qb">
          {metrics.map(metric => <div key={metric.label} className="border-l-2 border-green-600 pl-4" data-id="element-268" data-mp="3ujzpp9lc0gfn">
              <dt className="sr-only" data-id="element-269" data-mp="3pl6czjdvctgj">{metric.label}</dt>
              <dd data-id="element-270" data-mp="3pjlituvgvcj7">
                <span className="block font-display text-[32px] font-semibold leading-none tracking-[-0.02em] text-ink lg:text-[40px]" data-id="element-271" data-mp="3pn9cqv4tq0yg">
                  {metric.value}
                </span>
                <span className="mt-2 block text-[14px] font-semibold text-ink" data-id="element-272" data-mp="3gmb582v6fbb4">
                  {metric.label}
                </span>
                <span className="mt-1 block text-[13px] text-slate-500" data-id="element-273" data-mp="1eten5w2un8hi">{metric.note}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}